/* Ajout rapide depuis les cartes produit -> panier coulissant. Délégation d'événements :
   fonctionne aussi pour les produits chargés plus tard (filtres, pagination). */
(function () {
  'use strict';
  if (window.__quickAddReady) return;
  window.__quickAddReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartUrl = root + 'cart';
  var addUrl = root + 'cart/add';

  function stop(e) { e.preventDefault(); e.stopPropagation(); }
  function closeAll(except) {
    document.querySelectorAll('.qa.is-open').forEach(function (q) {
      if (q === except) return;
      q.classList.remove('is-open');
      var t = q.querySelector('[data-qa-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function drawer() { return document.getElementById('CartDrawer'); }
  function drawerOpen() {
    var d = drawer();
    return !!d && (d.classList.contains('drawer--is-open') || document.documentElement.classList.contains('js-drawer-open-right'));
  }
  function shownCount() {
    var d = drawer(); if (!d) return null;
    var el = d.querySelector('[data-products] [data-count]');
    return el ? parseInt(el.getAttribute('data-count'), 10) : null;
  }
  function rebuildDrawer() {
    var d = drawer(); if (!d) return Promise.resolve();
    return fetch(cartUrl + '?view=ajax', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('.cart__items');
        var target = d.querySelector('[data-products]');
        if (!items || !target) return;
        target.innerHTML = doc.body.innerHTML;
        d.classList.remove('is-empty');
        return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var sub = d.querySelector('[data-subtotal]');
          if (sub && window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
            sub.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
          }
        });
      }).catch(function () {});
  }
  function openDrawer() {
    if (drawerOpen()) return;
    var link = document.querySelector('.js-drawer-open-cart');
    if (link) link.click();
    else window.location.href = cartUrl;
  }

  function add(btn) {
    var qa = btn.closest('[data-qa]');
    var label = qa.querySelector('[data-qa-txt]');
    var initial = label ? label.textContent : '';
    qa.classList.add('is-busy');
    if (label) label.textContent = 'Ajout…';

    fetch(addUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        qa.classList.remove('is-busy');
        qa.classList.add('is-done');
        if (label) label.textContent = 'Ajouté ✓';
        document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.add('cart-link__bubble--visible'); });

        // Le thème reconstruit et ouvre le tiroir ; sinon on le fait nous-mêmes
        var item = data && data.items ? data.items[0] : data;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(openDrawer, 350);
        setTimeout(function () {
          fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
            var shown = shownCount();
            if (shown === null || shown !== cart.item_count) return rebuildDrawer();
          }).catch(function () {});
        }, 900);

        setTimeout(function () {
          qa.classList.remove('is-done', 'is-open');
          if (label) label.textContent = initial;
        }, 1800);
      })
      .catch(function (e) {
        qa.classList.remove('is-busy');
        if (label) label.textContent = (e && e.description) || 'Indisponible';
        setTimeout(function () { if (label) label.textContent = initial; }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qa-toggle]');
    if (toggle) {
      stop(e);
      var qa = toggle.closest('[data-qa]');
      var open = !qa.classList.contains('is-open');
      closeAll(qa);
      qa.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var btn = e.target.closest('[data-qa-add]');
    if (btn) {
      stop(e);
      if (!btn.disabled) add(btn);
      return;
    }
    if (e.target.closest('[data-qa]')) { stop(e); return; }
    closeAll(null);
  }, true);
})();
